/**
 * require.js allows you to load external URLs in the same way that you load internal ones.
 * However, since Webpack is really more of a compile-time bundler, it doesn't have runtime
 * features like that. Hence, this module takes care of loading external libraries in an
 * asynchronous manner using script.js. Note that Karma and server-side isomorphic rendering
 * override 'scriptjs' to 'utils/mock-scriptjs' so that we don't make real network requests.
 *
 * This module returns an object containing loaders for each external source. If external sources
 * are disabled, the loaders are basically no-ops. It's safe to call the loaders twice, but with
 * different callbacks.
 */

import { getConfigData } from '../data/get-config-data';
function addScript(url, cb) {
  if (typeof window === 'undefined') {
    throw new Error('Cannot load external scripts on the server');
  }
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  script.onload = () => {
    if (typeof cb === 'function') {
      cb();
    }
  };
  document.head.appendChild(script);
}
const loaders = {
  loadFacebookSDK: function loadFacebookSDK(cb) {
    const udConfig = getConfigData();
    if (udConfig.brand.is_external_sources_enabled && udConfig.brand.is_third_party_marketing_enabled) {
      const url = 'https://connect.facebook.net/en_US/sdk.js';
      addScript(url, () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof cb !== 'undefined' && typeof window.FB !== 'undefined') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          cb(window.FB);
        }
      });
    }
  },
  loadGoogleAuth: function loadGoogleAuth(cb) {
    const udConfig = getConfigData();
    if (udConfig.brand.is_external_sources_enabled) {
      const url = 'https://accounts.google.com/gsi/client';
      addScript(url, () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof cb !== 'undefined' && typeof window.google !== 'undefined') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          cb(window.google);
        }
      });
    }
  }
};
export const udExternalLoaders = loaders;
//# sourceMappingURL=ud-external-loaders.js.map